import { render, staticRenderFns } from "./PermissionValidation.component.vue?vue&type=template&id=3fff2e73"
import script from "./PermissionValidation.component.vue?vue&type=script&lang=js"
export * from "./PermissionValidation.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports